import React, { useState } from 'react';
import {
  Button, Modal, message, Tabs,
} from 'antd';
import ModalConfirm from 'components/Utils/ModalConfirm';
import PropTypes from 'prop-types';
import GalleryGrid from './GalleryGrid/GalleryGrid';
import UploadSection from './UploadView/UploadSection';
import './GalleryModal.less';

const GalleryModal = (props) => {
  const {
    handleCoverImage, coverImage, token,
  } = props;

  const [openModal, setOpenModal] = useState(false);
  const [cleanChild, setCleanChild] = useState(false);
  const [imageSelected, setImageSelected] = useState('');
  const [uploadedImage, setUploadedImage] = useState('');
  const modalButtonText = coverImage ? 'Editar Imagen' : 'Seleccionar Imagen';

  const { TabPane } = Tabs;

  /**
   * handle ok confirm modal
   */
  const handleConfirmModal = () => {
    message.success('Imagen de Portada seleccionada');
    handleCoverImage(uploadedImage || imageSelected);
    setCleanChild(!cleanChild);
    setOpenModal(false);
  };

  /**
   * Props object to send it to confirm modal;
   */
  const ConfirmModalProps = {
    title: '¿Desea confirmar?',
    content: 'Se va a seleccionar la imagen',
    action: handleConfirmModal,
  };

  /**
   * show modal handler.
   */
  const showModal = () => {
    setOpenModal(true);
  };

  /**
   * ok father modal
   */
  const handleOkFatherModal = () => {
    const { title, content, action } = ConfirmModalProps;
    ModalConfirm(title, content, action);
  };

  const handleCancelModal = () => {
    setCleanChild(!cleanChild);
    setOpenModal(false);
  };

  return (
    <div className="gallery-modal-container">
      <div className="gallery-modal-label">
        <h3>Imagen de Portada</h3>
      </div>

      <Button type="primary" onClick={showModal} className="gallery-modal-button">{modalButtonText}</Button>
      <Modal className="gallery-modal-component" visible={openModal} onOk={handleOkFatherModal} onCancel={handleCancelModal} width="75vw">
        <Tabs defaultActiveKey="1">
          <TabPane tab="Galería" key="1">
            <GalleryGrid
              handleSelectedImage={setImageSelected}
              coverImage={coverImage}
              cleanChild={cleanChild}
            />
          </TabPane>
          <TabPane tab="Subir Imagen" key="2">
            <UploadSection
              handleUploadImage={setUploadedImage}
              token={token}
            />
          </TabPane>
        </Tabs>
      </Modal>
    </div>
  );
};

GalleryModal.propTypes = {
  handleCoverImage: PropTypes.func.isRequired,
  coverImage: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
};

export default GalleryModal;
